module.exports = __webpack_public_path__ + "static/img/ruleThree_text.6822748.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/prebook/popup/ruleThree_text.png
// module id = VOrh
// module chunks = 1